// components/StrategyCombinationRow.js
import React from "react";
import { getProtocolLogoText } from "../config";
import "../App.css";

export default function StrategyCombinationRow({
  type,
  asset,
  yieldSource,
  apy,
}) {
  const isCollateral = type === "collateral";
  const assetLogo = `${asset}.png`;
  const protocolLogo = getProtocolLogoText(yieldSource) || "";

  return (
    <div className="strategy-combination-row">
      <div className="strategy-label-row">
        <span>{isCollateral ? "Collateral" : "Borrow"}</span>
        <span>{isCollateral ? "Yield Source" : "From"}</span>
      </div>
      <div className="strategy-combination-content">
        {/* Asset column */}
        <div className="strategy-asset-section">
          <img
            src={`/${assetLogo}`}
            alt={asset}
            className="strategy-asset-logo"
          />
          <span className="strategy-asset-name">{asset}</span>
        </div>

        {/* Arrow column */}
        <img src="/arrow.png" alt="arrow" className="strategy-arrow-icon" />

        {/* Yield column */}
        <div className="strategy-yield-section">
          {protocolLogo ? (
            <img
              src={`/${protocolLogo}`}
              alt={yieldSource}
              className="strategy-yield-logo"
            />
          ) : (
            <div className="strategy-yield-logo-placeholder" />
          )}
          <span className="strategy-yield-name">
            {yieldSource.charAt(0).toUpperCase() + yieldSource.slice(1)}
          </span>
        </div>

        {/* APY box */}
        <div className={`strategy-apy-box ${isCollateral ? "green" : "red"}`}>
          {apy}%
        </div>
      </div>
    </div>
  );
}
